import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import Category2productDashboard from '../Category2productDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function Category2productPage() {
    const dispatch = useDispatch();
    const { Category2productList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < Category2productDashboard />
    )

}